import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import SubscriptionForm from '../components/SubscriptionForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  cancelSubscriptionCreate,
  editSubscriptionRequest,
  fetchSubscriptionById,
} from '../../api/subscriptions/subscriptionSlice';

const SubscriptionEditPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, selectedSubscription } = useSelector((state) => state.subscriptions);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(fetchSubscriptionById(id));
    }
  }, [dispatch, id]);

  const handleUpdate = async (data) => {
    console.log(data);
    dispatch(editSubscriptionRequest(data));
    return navigate('/subscriptions');
  };

  function handleCancel() {
    dispatch(cancelSubscriptionCreate());
    return navigate('/subscriptions');
  }

  if (loading) {
    return null;
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>
        Update Subscription
      </Typography>
      <SubscriptionForm
        onSubmit={handleUpdate}
        onCancel={handleCancel}
        buttonText="Save"
        initialData={{
          ...selectedSubscription,
          organization_id: selectedSubscription?.organization_id,
          plan_id: selectedSubscription?.plan_id,
        }}
        isEdit={true}
      />
    </Box>
  );
};

export default SubscriptionEditPage;
